import React from 'react';
import './weatherDetails.css';

/**
 * Résumé client / séjour.
 */
const WeatherClientSummary = ({ summary }) => {
    if (!summary) return null;

    const fields = [
        { label: 'Client', value: summary.fullName },
        { label: 'Email', value: summary.email },
        { label: 'Téléphone', value: summary.phone },
        { label: 'Code client', value: summary.clientCode },
        { label: 'Réservation', value: summary.reservationNumber },
        { label: 'Code police', value: summary.policyCode },
        { label: 'Destination', value: summary.destination },
        { label: 'Dates de voyage', value: summary.travelDates },
    ];

    return (
        <section className="wd-card wd-client wd-slide-up" aria-label="Informations client">
            <div className="wd-card__header">
                <h3 className="wd-card__title">Informations client</h3>
            </div>
            <div className="wd-card__body">
                <div className="wd-client__grid">
                    {fields.map((field) => (
                        <div key={field.label}>
                            <div className="wd-client__label">{field.label}</div>
                            <div className="wd-client__value">{field.value || '—'}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default WeatherClientSummary;
